<div class="ltms-input-container">
    <input *ngIf="type != 'textarea'" 
        (input)="onInput($event)" 
        (change)="onChange($event)"
        (keyup.enter)="onEnter($event)"
        (keyup)="onKeyup($event)"
        (keydown)="onKeydown($event)"
        [placeholder]="placeholder"
        [attr.maxlength]="maxlength"
        [attr.min]="min"
        [attr.max]="max"
        [type]="type" 
        [(ngModel)]="value"
        [readonly]="readOnly"
        [disabled]="disabled">

    <textarea *ngIf="type == 'textarea'" 
        (input)="onInput($event)" 
        (change)="onChange($event)"
        (keyup.enter)="onEnter($event)"
        (keyup)="onKeyup($event)"
        (keydown)="onKeydown($event)"
        [placeholder]="placeholder"
        [(ngModel)]="value"
        [attr.maxlength]="maxlength"
        [rows]="rows"
        [readonly]="readOnly"
        [disabled]="disabled"></textarea>
</div>